<template>
  <v-main>
    <div class="d-flex align-center justify-center fill-height">
      <v-card class="pa-4" width="28rem">
        <v-card-title class="justify-center py-7">
          <h2 class="font-weight-medium">BAHANDI</h2>
        </v-card-title>

        <v-card-text class="py-0">
          <p class="font-weight-medium text--primary mb-2 text-h6">
            Добро пожаловать!
          </p>
          <p class="mb-2">
            Пожалуйста, введите свои учетные данные, чтобы войти в систему.
          </p>
        </v-card-text>

        <v-card-text>
          <v-form @submit.prevent="login">
            <v-text-field
              class="mb-3"
              hide-details="auto"
              outlined
              placeholder="ИИН"
              v-model="formData.iin"
              :error-messages="hasError ? errorMessage : ''"
              @change="resetError"
            ></v-text-field>

            <v-text-field
              hide-details="auto"
              outlined
              placeholder="Номер карточки"
              v-model="formData.card"
              :error-messages="hasError ? errorMessage : ''"
              type="card"
              @change="resetError"
            ></v-text-field>

            <v-btn class="mt-6" block color="primary" type="submit"
              >Войти</v-btn
            >
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-main>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        iin: "",
        card: "",
      },
      hasError: false,
      errorMessage: "Не нашли пользователя",
      isAuth: false
    };
  },
  methods: {
    login: function() {
        this.$api.login({}, this.formData).then((res) => {
          this.$store.dispatch('login', res.data)
          this.$router.push('/')
        }).catch(() => {
          this.hasError = true;
        })
    },
    resetError: function() {
      this.hasError = false;
    }
  }
}
</script>